import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { WsLandingService } from 'src/app/ws/wsLanding/ws-landing.service';
import { MBannerImageListRequest, MBannerImageListResponseData, MGenderSupplimentRequest, MTrendingProductRequest } from '../homepage/homepage.module';
import { lastValueFrom } from 'rxjs';
import { WsSubHeaderService } from 'src/app/ws/wsSubHeader/ws-sub-header.service';

@Component({
  selector: 'app-mens-section',
  templateUrl: './mens-section.component.html',
  styleUrls: ['./mens-section.component.scss']
})
export class MensSectionComponent {
  supSlider: OwlOptions = {
    loop: true,
    margin: 10,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 3000,
    smartSpeed: 2500,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
      },
      768: {
        items: 2,
        margin: 20
      },
      992: {
        items: 2,
        margin: 20
      },
      1300: {
        items: 3,
        margin: 60
      }
    }
  }

  tProductSlider: OwlOptions = {
    loop: true,
    margin: 10,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 3000,
    smartSpeed: 2500,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
      },
      992: {
        items: 3,
        margin: 20
      },
      1300: {
        items: 4,
        margin: 20
      },
      1500: {
        items: 4,
        margin: 70
      }
    }
  }

  faceSlider: OwlOptions = {
    loop: true,
    margin: 10,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 3000,
    smartSpeed: 2500,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
      },
      768: {
        items: 2,
        margin: 10
      },
      992: {
        items: 2,
        margin: 20
      },
      1100: {
        items: 3,
        margin: 30
      }
    }
  }

  mTrendingProductReq: MTrendingProductRequest = new MTrendingProductRequest();
  msupplimentReq: MGenderSupplimentRequest = new MGenderSupplimentRequest();
  mBannerReq: MBannerImageListRequest = new MBannerImageListRequest();
  images_banner: any = [];
  imagePreview_banner: any = [];
  images_skin_banner: any = [];
  imagePreview_skin_banner: any = [];
  images_suppliment_banner: any = [];
  imagePreview_suppliment_banner: any = [];
  supplimentProducts: any;
  trendingProducts: any;

  constructor(private wslandingservice: WsLandingService, private wssubheaderservice: WsSubHeaderService) { }

  ngOnInit() {
    this.getBannerImges('men_top_banner');
    this.getSkinBannerImges('men_skin_progress_banner');
    this.getSupplimentBannerImges('men_suppliment_banner');

    this.msupplimentReq.take = 3;
    this.msupplimentReq.skip = 0;
    this.msupplimentReq.gender = "1"; // Gender type 1=> Male 
    this.getSuppliments(this.msupplimentReq)

    this.mTrendingProductReq.take = 4;
    this.mTrendingProductReq.skip = 0;
    this.getTrendingProduct(this.mTrendingProductReq)
  }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used to get men_top_banner image
  * @param code :-  This param is used to get men_top_banner image
  */
  async getBannerImges(code: any) {
    this.mBannerReq.type = code;
    const listBanner = this.wslandingservice.getImageListByCodeAndType(this.mBannerReq)
    await lastValueFrom(listBanner).then(async response => {
      if (response && response.statusCode == 200) {
        response.data.forEach((imagebanner: MBannerImageListResponseData, i: any) => {
          let imgurl = imagebanner.path.replaceAll("\\", "/")
          this.imagePreview_banner.push(imgurl);
        })
      }
    })
  }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used to get men_skin_progress_banner image
  * @param code :-  This param is used to get men_skin_progress_banner image
  */
  async getSkinBannerImges(code: any) {
    this.mBannerReq.type = code;
    const listBanner = this.wslandingservice.getImageListByCodeAndType(this.mBannerReq)
    await lastValueFrom(listBanner).then(async response => {
      if (response && response.statusCode == 200) {
        response.data.forEach((imageskinbanner: MBannerImageListResponseData, i: any) => {
          let imgurl = imageskinbanner.path.replaceAll("\\", "/")
          this.imagePreview_skin_banner.push(imgurl);
        })
      }
    })
  }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used to get men_suppliment_banner image
  * @param code :-  This param is used to get men_suppliment_banner image
  */
  async getSupplimentBannerImges(code: any) {
    this.mBannerReq.type = code;
    const listBanner = this.wslandingservice.getImageListByCodeAndType(this.mBannerReq)
    await lastValueFrom(listBanner).then(async response => {
      if (response && response.statusCode == 200) {
        response.data.forEach((imagesupplimentbanner: MBannerImageListResponseData, i: any) => {
          let imgurl = imagesupplimentbanner.path.replaceAll("\\", "/")
          this.imagePreview_suppliment_banner.push(imgurl);
        })
      }
    })
  }

  /**
  * Date:- 10-06-2023
  * Method :- This method is used to get Trending Products
  * @param trendingProductReq :-  This param is used to get Trending Products
  */
  async getTrendingProduct(trendingProductReq: any) {
    const listTrendingProduct = this.wslandingservice.getTrendingPoduct(trendingProductReq)
    await lastValueFrom(listTrendingProduct).then(async response => {
      if (response && response.statusCode == 200) {
        this.trendingProducts = response.data
      }
    })
  }

  /**
  * Date:- 10-06-2023
  * Method :- This method is used to get Suppliment Products
  * @param suppimentReq :-  This param is used to get Suppliment Products
  */
  async getSuppliments(suppimentReq: any) {
    const listSuppliment = this.wslandingservice.getPoductByGenderSuppiment(suppimentReq)
    await lastValueFrom(listSuppliment).then(async response => {
      if (response && response.statusCode == 200) {
        this.supplimentProducts = response.data
      }
    })
  }
}
